module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cT8cT"))).then(() => parcelRequire('9Lwss'));